// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__rnCY9","savePackageButton":"ClientWallet_savePackageButton__GUwB3"};